import { isValuationStatus } from './case-status.helper';

export const getCaseDetailsLink = (caseStatus: number, caseId: string) => {
  if (isValuationStatus(caseStatus)) {
    return ['/', 'valuations', caseId];
  } else {
    return ['/', 'stock', caseId];
  }
};
